import { ApiResponse } from '@nf/types/api';
import { fetchComposer } from '@nf/utils-common/compose-fetch';
import { useApiBackendInfo } from '@/hooks/query/use-api-backend-info';
import { useQuery } from '@tanstack/react-query';
import queryKeys from '@/constants/query-keys';
import { useLicSettings } from '@/domains/config/hooks/use-lic-settings';
import { ApiBackendInfo } from '@/hooks/query/athena/types';
import { WcPromotionWinningNotifyDto } from './types';
import { useState } from 'react';
import { AccountActStatus } from '@nf/utils-common/constants';
import { useAccountStatus } from '@/hooks/query/account';

const fetchWcPromotionWinningNotify = async (
	apiBackendInfo: ApiBackendInfo
): Promise<ApiResponse<WcPromotionWinningNotifyDto>> => {
	const response = await fetchComposer.getWithBearer(`${apiBackendInfo.url}/WcPromotion/GetWcPromotionWinningNotify`)(apiBackendInfo.token);
	if (!response.ok) {
		throw new Error(`${response.status}: ${response.statusText}`);
	}
	return await response.json();
};

const setWcPromotionWinningNotify = async (apiBackendInfo: ApiBackendInfo): Promise<ApiResponse<void>> => {
	const response = await fetchComposer.getWithBearer(`${apiBackendInfo.url}/WcPromotion/SetWcPromotionWinningNotify`)(apiBackendInfo.token);
	if (!response.ok) {
		throw new Error(`${response.status}: ${response.statusText}`);
	}
	return await response.json();
};

// 獲得派獎通知與set已派獎通知的
export const useWcPromotionWinningNotify = () => {
	const { enableWcPromotionWeeklyLottery, enableWcPromotionAfterParty } = useLicSettings();
	const apiBackendInfo = useApiBackendInfo();
	const isWcPromotionEnabled = enableWcPromotionWeeklyLottery || enableWcPromotionAfterParty;
	const { data: actStatus } = useAccountStatus();
	const [hasCheckNotify, setHasCheckNotify] = useState(false);
	const { data, isLoading, isError, error, refetch } = useQuery({
		queryKey: [queryKeys.WC_PROMOTION_WINNING_NOTIFY, apiBackendInfo.url],
		queryFn: () => fetchWcPromotionWinningNotify(apiBackendInfo),
		staleTime: Infinity,
		cacheTime: Infinity,
		retry: 5,
		retryDelay: 3000,
		enabled: isWcPromotionEnabled 
			&& apiBackendInfo.isReady 
			&& !!apiBackendInfo.token 
			&& actStatus === AccountActStatus.Deposited
			&& !hasCheckNotify,
		onSuccess: (response) => {
			if (response.Data) {
				setHasCheckNotify(true);
			}
		}
	});

	const setNotify = async () => {
		await setWcPromotionWinningNotify(apiBackendInfo);
	};

	return {
		data: data?.Data,
		isLoading,
		isError,
		error,
		refetch,
		setWcPromotionWinningNotify: setNotify
	};
};
